import layoutHeaderAside from '@/layout/header-aside';

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/tyc',
  name: 'tyc',
  meta: {
    auth: true
  },
  redirect: {
    name: 'tyc/media'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'media',
      name: `${pre}media`,
      component: _import('tyc/media'),
      meta: {
        title: '自媒体雷达'
      }
    },
    {
      path: 'rank',
      name: `${pre}rank`,
      component: _import('tyc/rank'),
      meta: {
        title: '榜单排名'
      }
    },
    {
      path: 'chat',
      name: `${pre}chat`,
      component: _import('tyc/chat'),
      meta: {
        title: '社交群雷达'
      }
    },
    {
      path: 'report',
      name: `${pre}report`,
      component: _import('tyc/report'),
      meta: {
        title: '分析报告'
      }
    },
    {
      path: 'matrix',
      name: `${pre}matrix`,
      component: _import('tyc/matrix'),
      meta: {
        title: '矩阵台账'
      }
    },
    {
      path: 'alert',
      name: `${pre}alert`,
      component: _import('tyc/alert'),
      meta: {
        title: '违规文章提醒'
      }
    },
    {
      path: 'setting/plan',
      name: `${pre}plan`,
      component: _import('tyc/plan'),
      meta: {
        title: '方案设置'
      } 
    },
    {
      path: 'setting/contacts',
      name: `${pre}contacts`,
      component: _import('tyc/contacts'),
      meta: {
        title: '联系人设置'
      }
    },
    {
      path: 'setting/alert',
      name: `${pre}setting-alert`,
      component: _import('tyc/setting/alert'),
      meta: {
        title: '预警设置'
      }
    },
    {
      path: 'setting/word',
      name: `${pre}word`,
      component: _import('tyc/word'),
      meta: {
        title: '敏感词设置'
      }
    }
  ])('tyc/')
}
